module.exports = __webpack_public_path__ + "static/media/SM_79.c832446a.jpg";